var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer(props) {
        var _this = _super.call(this, props) || this;
        _this.SCROLL_TO_TOP_INTERVAL = 3; //milliseconds to pause before next scroll action
        _this._isMounted = false;
        _this.dockBackToTop = function () {
            // var headerHeight = document.getElementById('header').offsetHeight;
            // var contentAreaHeight = document.getElementById('contentArea').offsetHeight;
            var footerHeight = document.getElementById('footer').offsetHeight;
            var footerHeightPad = footerHeight + 35;
            var top1 = document.getElementById('s4-workspace').scrollTop;
            // var distToFooter = document.getElementById('footer').getBoundingClientRect().top + top1;
            // var dockingHeight = (headerHeight + contentAreaHeight);
            // var screenHeight = document.getElementById('s4-workspace').offsetHeight;
            var screenWidth = document.getElementById('s4-bodyContainer').offsetWidth;
            var contentAreaWidth = document.getElementById('contentArea').offsetWidth;
            var gutterWidth = Math.round(((screenWidth - contentAreaWidth) / 2) + 51);
            var rightPosition;
            if (_this.state.isMobile) {
                rightPosition = 17;
            }
            else {
                rightPosition = gutterWidth; // - 48;
            }
            // change after fixed header 
            // no longer docking
            // if( (top1 + screenHeight) > (headerHeight + contentAreaHeight + 10)) {
            //     if( !this.state.dockBTT){
            //         this.setState({
            //             dockBTT: true 
            //         }, ()=>{
            //             console.log("dock");
            //         });
            //     }
            // }else {
            //     if( this.state.dockBTT){
            //         this.setState({
            //             dockBTT: false
            //         }, () => {
            //             console.log("undock");
            //         });
            //     }
            // }
            // need to recheck scroll height 
            if (!_this.state.hasVScroll) {
                var hasVScroll = document.getElementById('s4-workspace').offsetHeight < document.getElementById('s4-bodyContainer').offsetHeight ? true : false;
                _this.setState({
                    hasVScroll: hasVScroll
                });
            }
            if (top1 > 0) {
                if (!_this.state.showBTT) {
                    _this.setState({
                        showBTT: true
                    });
                }
            }
            else {
                if (_this.state.showBTT) {
                    _this.setState({
                        showBTT: false
                    });
                }
            }
            if (_this.state.gutterWidth != rightPosition || _this.state.footerTop != footerHeightPad) {
                _this.setState({
                    gutterWidth: rightPosition,
                    footerTop: footerHeightPad
                });
            }
        };
        _this.BackToTopClick = function (e) {
            // console.log("inside BackToTopClick");
            var workspace = document.getElementById('s4-workspace');
            // var scrollTopOrig: number = workspace.scrollTop;
            // var scrollTop: number = scrollTopOrig;
            // var bezierStepX: number = (this.SCROLL_TO_TOP_INTERVAL / 1000);
            // var currentStepX: number = 0;
            // var currentBezierX: number = 0;
            //let bezierEasing: BezierEasing = new this.bezierEasing(.77,0,.21,.99);
            // let bezierEasing = new this.bezierEasing(.77,0,.21,.99);
            // let bezierEasing = new this.bezierEasing(.1,.9,.8,.99);
            // var scrollInterval:number = window.setInterval(() => {
            //     if ( document.getElementById('s4-workspace').scrollTop > 0 && (currentStepX < 100)) {
            //         //document.getElementById('s4-workspace').scrollBy( 0, (scrollStep * -1) );
            //         //get the current BezierX
            //         currentBezierX = bezierEasing.easing((bezierStepX * currentStepX < 1 ? bezierStepX * currentStepX : 1));
            //         //get what this scroll top should now be, closing in on 0
            //         scrollTop = scrollTopOrig - (scrollTopOrig * currentBezierX);
            //         document.getElementById('s4-workspace').scrollTop = scrollTop;
            //         currentStepX++;
            //         console.log("inside setInterval - scrollInterval, scrollTop", scrollInterval, scrollTop);
            //     }
            //     else {
            //         clearInterval(scrollInterval); 
            //     }
            // }, this.SCROLL_TO_TOP_INTERVAL);
            document.getElementById('s4-workspace').scrollTop = 0;
        };
        _this.AccordionHeaderClick = function (e, itemId) {
            e.preventDefault();
            e.stopPropagation();
            if (itemId == "footerHeader1") {
                if (!_this.state.accordion1Open) { // 1
                    _this.setState({
                        accordion1Open: true,
                        accordion2Open: false,
                        accordion3Open: false,
                        accordion4Open: false
                    });
                }
                else {
                    _this.setState({
                        accordion1Open: false
                    });
                }
            }
            if (itemId == "footerHeader2") {
                if (!_this.state.accordion2Open) { // 2
                    _this.setState({
                        accordion1Open: false,
                        accordion2Open: true,
                        accordion3Open: false,
                        accordion4Open: false
                    });
                }
                else {
                    _this.setState({
                        accordion2Open: false
                    });
                }
            }
            if (itemId == "footerHeader3") {
                if (!_this.state.accordion3Open) { // 3
                    _this.setState({
                        accordion1Open: false,
                        accordion2Open: false,
                        accordion3Open: true,
                        accordion4Open: false
                    });
                }
                else {
                    _this.setState({
                        accordion3Open: false
                    });
                }
            }
            if (itemId == "footerHeader4") {
                if (!_this.state.accordion4Open) { // 4
                    _this.setState({
                        accordion1Open: false,
                        accordion2Open: false,
                        accordion3Open: false,
                        accordion4Open: true
                    });
                }
                else {
                    _this.setState({
                        accordion4Open: false
                    });
                }
            }
        };
        _this.state = {
            hasVScroll: false,
            showBTT: false,
            gutterWidth: 0,
            footerTop: 0,
            footerCopyright: "",
            footerLogo: "",
            footerLogoBD: false,
            footerLogoBDText1: "",
            footerLogoBDText2: "",
            backToTop: "",
            footerHeader1: "",
            footerHeader2: "",
            footerHeader3: "",
            footerHeader4: "",
            accordion1Open: false,
            accordion2Open: false,
            accordion3Open: false,
            accordion4Open: false,
            footerLinksList1: [],
            footerLinksList2: [],
            footerLinksList3: [],
            footerLinksList4: [],
            socialLinksList1: []
        };
        _this.onComponentResize = _this.onComponentResize.bind(_this);
        return _this;
    }
    Footer.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var SnippetHelper, BezierEasing, Utils;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._isMounted = true;
                        return [4 /*yield*/, import(
                            /* webpackChunkName: 'helpers' */
                            '@pm-tt/common-components/lib/SnippetHelper')];
                    case 1:
                        SnippetHelper = (_a.sent()).SnippetHelper;
                        return [4 /*yield*/, import(
                            /* webpackChunkName: 'helpers' */
                            '@pm-tt/common-components/lib/BezierEasing')];
                    case 2:
                        BezierEasing = (_a.sent()).BezierEasing;
                        return [4 /*yield*/, import(
                            /* webpackChunkName: 'helpers' */
                            '@pm-tt/common-components/lib/Utils')];
                    case 3:
                        Utils = (_a.sent()).Utils;
                        this.utils = Utils;
                        this.snippetHelper = SnippetHelper;
                        this.bezierEasing = BezierEasing;
                        this.snippetHelper.getSnippet("#footerCopyright").then(function (snippet) {
                            if (snippet.length > 0 && _this._isMounted) {
                                // check for {CopyrightYear} text and replace with current year
                                if (snippet[0].snippet.includes("{CopyrightYear}")) {
                                    _this.setState({ footerCopyright: snippet[0].snippet.replace("{CopyrightYear}", new Date().getFullYear()) });
                                }
                                else {
                                    _this.setState({ footerCopyright: snippet[0].snippet });
                                }
                            }
                        });
                        this.snippetHelper.getSnippet("#footerLogo").then(function (snippet) {
                            if (snippet.length > 0 && _this._isMounted) {
                                _this.setState({ footerLogo: snippet[0] });
                            }
                        });
                        this.snippetHelper.getSnippet("#logoText1").then(function (snippet) {
                            if (snippet.length > 0 && _this._isMounted) {
                                _this.setState({ footerLogoBD: true, footerLogoBDText1: snippet[0].snippet });
                            }
                        });
                        this.snippetHelper.getSnippet("#logoText2").then(function (snippet) {
                            if (snippet.length > 0 && _this._isMounted) {
                                _this.setState({ footerLogoBD: true, footerLogoBDText2: snippet[0].snippet });
                            }
                        });
                        this.snippetHelper.getSnippet("#backToTop").then(function (snippet) {
                            if (snippet.length > 0 && _this._isMounted) {
                                _this.setState({ backToTop: snippet[0] });
                            }
                        });
                        this.snippetHelper.getSnippet("#footerHeader1").then(function (snippet) {
                            if (snippet.length > 0 && _this._isMounted) {
                                _this.setState({ footerHeader1: snippet[0].snippet });
                            }
                        });
                        this.snippetHelper.getSnippet("#footerHeader2").then(function (snippet) {
                            if (snippet.length > 0 && _this._isMounted) {
                                _this.setState({ footerHeader2: snippet[0].snippet });
                            }
                        });
                        this.snippetHelper.getSnippet("#footerHeader3").then(function (snippet) {
                            if (snippet.length > 0 && _this._isMounted) {
                                _this.setState({ footerHeader3: snippet[0].snippet });
                            }
                        });
                        this.snippetHelper.getSnippet("#footerHeader4").then(function (snippet) {
                            if (snippet.length > 0 && _this._isMounted) {
                                _this.setState({ footerHeader4: snippet[0].snippet });
                            }
                        });
                        this.snippetHelper.getSnippet("#footerLinks1").then(function (snippet) {
                            if (snippet.length > 0 && _this._isMounted) {
                                _this.setState({ footerLinksList1: snippet });
                            }
                        });
                        this.snippetHelper.getSnippet("#footerLinks2").then(function (snippet) {
                            if (snippet.length > 0 && _this._isMounted) {
                                _this.setState({ footerLinksList2: snippet });
                            }
                        });
                        this.snippetHelper.getSnippet("#footerLinks3").then(function (snippet) {
                            if (snippet.length > 0 && _this._isMounted) {
                                _this.setState({ footerLinksList3: snippet });
                            }
                        });
                        this.snippetHelper.getSnippet("#footerBottomLinks").then(function (snippet) {
                            if (snippet.length > 0 && _this._isMounted) {
                                _this.setState({ footerLinksList4: snippet });
                            }
                        });
                        this.snippetHelper.getSnippet("#footerIconLinks").then(function (snippet) {
                            if (snippet.length > 0 && _this._isMounted) {
                                _this.setState({ socialLinksList1: snippet });
                            }
                        });
                        document.getElementById('s4-workspace').addEventListener('scroll', this.dockBackToTop);
                        // adding resize listener -- if the component resizes, we call onComponentResize();
                        window.addEventListener('resize', function () {
                            _this.onComponentResize();
                        });
                        // we call onComponentResize() initially when the component first loads
                        this.onComponentResize();
                        return [2 /*return*/];
                }
            });
        });
    };
    Footer.prototype.onComponentResize = function () {
        var _this = this;
        var mobileBreakpoint = 991;
        var smallerThanMobileBreakpoint = window.innerWidth <= mobileBreakpoint ? true : false;
        var hasVScroll = document.getElementById('s4-workspace').offsetHeight < document.getElementById('s4-bodyContainer').offsetHeight ? true : false;
        this.setState({
            isMobile: smallerThanMobileBreakpoint,
            hasVScroll: hasVScroll
        }), function () {
            _this.dockBackToTop();
        };
    };
    Footer.prototype.componentWillUnmount = function () {
        var _this = this;
        this._isMounted = false;
        // remove the resize listener when this component is unmounted
        window.addEventListener('resize', function () {
            _this.onComponentResize();
        });
        document.getElementById('s4-workspace').removeEventListener('scroll', this.dockBackToTop);
    };
    Footer.prototype.render = function () {
        var _this = this;
        this.scrollBarWidth = this.utils ? this.utils.findScrollbarWidth() : 0;
        if (this.state.footerLinksList1.length > 0) {
            var footerList1 = null;
            footerList1 = this.state.footerLinksList1.map(function (linkItem, i) {
                return React.createElement("li", { "data-order": linkItem.order, key: i },
                    React.createElement("a", { href: linkItem.url.url, target: _this.state.footerLinksList1[i].openNew ? "_blank" : "" }, linkItem.url.description));
            });
            var footerUL1 = React.createElement("ul", { id: "footerLinks1", className: this.state.accordion1Open ? "active" : "" }, footerList1);
        }
        if (this.state.footerLinksList2.length > 0) {
            var footerList2 = null;
            footerList2 = this.state.footerLinksList2.map(function (linkItem, i) {
                return React.createElement("li", { "data-order": linkItem.order, key: i },
                    React.createElement("a", { href: linkItem.url.url, target: _this.state.footerLinksList2[i].openNew ? "_blank" : "" }, linkItem.url.description));
            });
            var footerUL2 = React.createElement("ul", { id: "footerLinks2", className: this.state.accordion2Open ? "active" : "" }, footerList2);
        }
        if (this.state.footerLinksList3.length > 0) {
            var footerList3 = null;
            footerList3 = this.state.footerLinksList3.map(function (linkItem, i) {
                return React.createElement("li", { "data-order": linkItem.order, key: i },
                    React.createElement("a", { href: linkItem.url.url, target: _this.state.footerLinksList3[i].openNew ? "_blank" : "" }, linkItem.url.description));
            });
            var footerUL3 = React.createElement("ul", { id: "footerLinks3", className: this.state.accordion3Open ? "active" : "" }, footerList3);
        }
        if (this.state.socialLinksList1.length > 0) {
            var socialList1 = null;
            socialList1 = this.state.socialLinksList1.map(function (linkItem, i) {
                return React.createElement("li", { "data-order": linkItem.order, key: i },
                    React.createElement("a", { href: linkItem.url.url, title: linkItem.url.description, target: _this.state.socialLinksList1[i].openNew ? "_blank" : "" },
                        React.createElement("i", { className: linkItem.icon }),
                        React.createElement("span", { className: "mobile-only" }, linkItem.url.description)));
            });
            var socialUL = React.createElement("ul", { id: "footerLinksRight1" }, socialList1);
        }
        if (this.state.footerLinksList4.length > 0) {
            var footerList4 = null;
            footerList4 = this.state.footerLinksList4.map(function (linkItem, i) {
                return linkItem.url.url.indexOf("cookiePopup") >= 0 ?
                    React.createElement("li", { "data-order": linkItem.order, key: i },
                        React.createElement("a", { href: "#cookie-preferences" }, linkItem.url.description))
                    :
                        React.createElement("li", { "data-order": linkItem.order, key: i },
                            React.createElement("a", { href: linkItem.url.url, target: _this.state.footerLinksList4[i].openNew ? "_blank" : "" }, linkItem.url.description));
            });
            var footerUL4 = React.createElement("ul", { id: "footerLinksLeft1", className: this.state.accordion4Open ? "active" : "" },
                footerList4,
                this.state.isMobile && socialList1);
        }
        if (this.state.footerHeader1.length > 0 && this.state.footerLinksList1.length > 0) {
            var footerHeader1 = null;
            if (this.state.isMobile) {
                footerHeader1 = React.createElement("button", { id: "footerHeader1", className: this.state.accordion1Open ? "footer__header open" : "footer__header", onClick: function (e) { _this.AccordionHeaderClick(e, 'footerHeader1'); } },
                    this.state.footerHeader1,
                    " ",
                    React.createElement("i", { className: "material__arrow" },
                        React.createElement("span", { className: "sr-only" }, "Expand/collapse")));
            }
            else {
                footerHeader1 = React.createElement("p", { id: "footerHeader1", className: this.state.accordion1Open ? "footer__header open" : "footer__header", onClick: function (e) { _this.AccordionHeaderClick(e, 'footerHeader1'); } },
                    this.state.footerHeader1,
                    " ",
                    React.createElement("i", { className: "material__arrow" },
                        React.createElement("span", { className: "sr-only" }, "Expand/collapse")));
            }
        }
        if (this.state.footerHeader2.length > 0 && this.state.footerLinksList2.length > 0) {
            var footerHeader2 = null;
            if (this.state.isMobile) {
                footerHeader2 = React.createElement("button", { id: "footerHeader2", className: this.state.accordion2Open ? "footer__header open" : "footer__header", onClick: function (e) { _this.AccordionHeaderClick(e, 'footerHeader2'); } },
                    this.state.footerHeader2,
                    " ",
                    React.createElement("i", { className: "material__arrow" },
                        React.createElement("span", { className: "sr-only" }, "Expand/collapse")));
            }
            else {
                footerHeader2 = React.createElement("p", { id: "footerHeader2", className: this.state.accordion2Open ? "footer__header open" : "footer__header", onClick: function (e) { _this.AccordionHeaderClick(e, 'footerHeader2'); } },
                    this.state.footerHeader2,
                    " ",
                    React.createElement("i", { className: "material__arrow" },
                        React.createElement("span", { className: "sr-only" }, "Expand/collapse")));
            }
        }
        if (this.state.footerHeader3.length > 0 && this.state.footerLinksList3.length > 0) {
            var footerHeader3 = null;
            if (this.state.isMobile) {
                footerHeader3 = React.createElement("button", { id: "footerHeader3", className: this.state.accordion3Open ? "footer__header open" : "footer__header", onClick: function (e) { _this.AccordionHeaderClick(e, 'footerHeader3'); } },
                    this.state.footerHeader3,
                    " ",
                    React.createElement("i", { className: "material__arrow" },
                        React.createElement("span", { className: "sr-only" }, "Expand/collapse")));
            }
            else {
                footerHeader3 = React.createElement("p", { id: "footerHeader3", className: this.state.accordion3Open ? "footer__header open" : "footer__header", onClick: function (e) { _this.AccordionHeaderClick(e, 'footerHeader3'); } },
                    this.state.footerHeader3,
                    " ",
                    React.createElement("i", { className: "material__arrow" },
                        React.createElement("span", { className: "sr-only" }, "Expand/collapse")));
            }
        }
        if ((this.state.footerLinksList4.length > 0 || this.state.socialLinksList1.length > 0)) {
            var footerHeader4 = null;
            if (this.state.isMobile) {
                footerHeader4 = React.createElement("button", { id: "footerHeader4", className: this.state.accordion4Open ? "footer__header open" : "footer__header", onClick: function (e) { _this.AccordionHeaderClick(e, 'footerHeader4'); } },
                    this.state.footerHeader4,
                    " ",
                    React.createElement("i", { className: "material__arrow" },
                        React.createElement("span", { className: "sr-only" }, "Expand/collapse")));
            }
            else {
                footerHeader4 = React.createElement("p", { id: "footerHeader4", className: this.state.accordion4Open ? "footer__header open" : "footer__header", onClick: function (e) { _this.AccordionHeaderClick(e, 'footerHeader4'); } },
                    this.state.footerHeader4,
                    " ",
                    React.createElement("i", { className: "material__arrow" },
                        React.createElement("span", { className: "sr-only" }, "Expand/collapse")));
            }
        }
        var logoLink = null;
        if (this.state.footerLogo && !this.state.footerLogoBD) {
            logoLink = React.createElement("div", { id: "footerLogo" },
                React.createElement("a", { href: this.state.footerLogo.url.url, target: this.state.footerLogo.openNew ? "_blank" : "" },
                    React.createElement("img", { src: this.state.footerLogo.snippet, alt: this.state.footerLogo.url.description })));
        }
        else if (this.state.footerLogo && this.state.footerLogoBD) {
            var logoText1 = null;
            var logoText2 = null;
            if (this.state.footerLogoBDText1 && this.state.footerLogoBDText1.length > 0) {
                logoText1 = React.createElement("span", { className: "logoBD-text1", dangerouslySetInnerHTML: { __html: this.state.footerLogoBDText1 } });
            }
            if (this.state.footerLogoBDText2 && this.state.footerLogoBDText2.length > 0) {
                logoText2 = React.createElement("span", { className: "logoBD-text2", dangerouslySetInnerHTML: { __html: this.state.footerLogoBDText2 } });
            }
            logoLink = React.createElement("div", { id: "footerLogo" },
                React.createElement("a", { href: this.state.footerLogo.url.url, target: this.state.footerLogo.openNew ? "_blank" : "" },
                    React.createElement("img", { src: this.state.footerLogo.snippet, alt: this.state.footerLogo.url.description })),
                React.createElement("div", { className: "logo-bd" },
                    logoText1,
                    logoText2));
        }
        if (this.state.backToTop && this.state.hasVScroll && this.state.showBTT) {
            var backToTopLink = null;
            backToTopLink = React.createElement("a", { href: "javascript:void(0);", role: "button", rel: "nofollow", title: this.state.backToTop.snippet, "aria-label": this.state.backToTop.snippet, id: "backToTop", style: { right: this.scrollBarWidth }, className: this.state.dockBTT ? "docked" : "", onClick: function (e) { _this.BackToTopClick(e); } },
                React.createElement("i", { className: "material" }));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { id: "footer-top", className: "row ", ref: function (el) { return _this.parentRef = el; } },
                backToTopLink,
                React.createElement("div", { className: "col-xs-12 col-md-3 order-last footer-logo-copyright" },
                    logoLink,
                    React.createElement("div", { id: "footerCopyright", dangerouslySetInnerHTML: { __html: this.state.footerCopyright } })),
                React.createElement("div", { className: "col-xs-12 col-md-3" },
                    footerHeader1,
                    footerUL1),
                React.createElement("div", { className: "col-xs-12 col-md-3" },
                    footerHeader2,
                    footerUL2),
                React.createElement("div", { className: "col-xs-12 col-md-3" },
                    footerHeader3,
                    footerUL3)),
            React.createElement("div", { id: "footer-bottom", className: "row" },
                React.createElement("div", { className: "col-xs-12 col-md-6" },
                    footerHeader4,
                    footerUL4),
                !this.state.isMobile && (React.createElement("div", { className: "col-xs-12 col-md-6" }, socialUL)))));
        // call on resize, we need the height of the content, so we can determine if the back to top button should be rendered
        // this.onComponentResize();
    }; // end render()
    return Footer;
}(React.Component));
export { Footer };
